import { mobileXXLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { SubHeading } from '../typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 60px;

  ${SubHeading} {
    padding: 0 30px;
  }

  @media screen and (${mobileXXLargeMax}) {
    ${SubHeading} {
      margin: 30px 0;
      padding: 0 15px;
      font-size: 26px;
      line-height: 33px;
      text-align: center;
    }
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`;

export const LeftArrow = styled.button`
  position: absolute;
  align-self: center;
  left: 28px;
  filter: drop-shadow(0px 0px 1px #000);
  z-index: 5;

  @media screen and (${tabletMax}) {
    left: 10px;
  }
`;

export const RightArrow = styled.button`
  position: absolute;
  align-self: center;
  right: 28px;
  filter: drop-shadow(0px 0px 1px #000);
  z-index: 5;

  @media screen and (${tabletMax}) {
    right: 10px;
  }
`;
